import { kv } from '@/services/platform';

// Access — только в памяти (короткоживущий). Refresh — в персисте (kv/Preferences).
// ВНИМАНИЕ v1: на native refresh должен лежать в Secure Storage (отдельный плагин) —
// сейчас Preferences; замена — drop-in, помечено как hardening после P1.
const REFRESH_KEY = 'td.auth.refresh';

let accessToken: string | null = null;

export const tokenStore = {
  getAccess(): string | null {
    return accessToken;
  },
  setAccess(token: string | null): void {
    accessToken = token;
  },
  async getRefresh(): Promise<string | null> {
    return kv.get(REFRESH_KEY);
  },
  async setRefresh(token: string | null): Promise<void> {
    if (token == null) await kv.remove(REFRESH_KEY);
    else await kv.set(REFRESH_KEY, token);
  },
  async clear(): Promise<void> {
    accessToken = null;
    await kv.remove(REFRESH_KEY);
  },
};
